import React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import Job from "../apiResources/Job";
import { Td } from "./library/Table";
import StatusTag from "./StatusTag";
import {
  exclusiveJobTooltip,
  percentageFeeTooltip,
  portalJobTooltip,
  premiumJobTooltip,
} from "../constants";
import StatusTagGroup from "./StatusTagGroup";

type JobTitleIdProps = {
  job: Job;
};

const JobTitleTd = (props: JobTitleIdProps) => {
  const { job } = props;

  const hasTags =
    job.exclusive ||
    job.employer?.premium ||
    job.employer?.portal ||
    job.employer?.isJobVendor;

  return (
    <Td>
      <div>{job.title}</div>
      {hasTags && (
        <TagGroup>
          <ReactTooltip
            multiline
            id="job-tag-tooltip"
            place="bottom"
            type="dark"
            effect="solid"
            aria-haspopup="true"
          />
          <StatusTagGroup>
            {job.exclusive && (
              <StatusTag
                data-for="job-tag-tooltip"
                data-tip={exclusiveJobTooltip}
              >
                Exclusive
              </StatusTag>
            )}
            {job.employer?.premium && (
              <StatusTag
                data-for="job-tag-tooltip"
                data-tip={premiumJobTooltip}
              >
                Premium
              </StatusTag>
            )}
            {job.employer?.portal && (
              <StatusTag data-for="job-tag-tooltip" data-tip={portalJobTooltip}>
                Portal
              </StatusTag>
            )}
            {job.employer?.isJobVendor && (
              <StatusTag
                data-for="job-tag-tooltip"
                data-tip={percentageFeeTooltip}
              >
                Split Fee
              </StatusTag>
            )}
          </StatusTagGroup>
        </TagGroup>
      )}
    </Td>
  );
};

const TagGroup = styled.div`
  margin-top: 0.5rem;
`;

export default JobTitleTd;
